import React, { useState } from 'react';
import { Button, Paper, TextField } from '@mui/material';
import * as actions from '../store/actions/GlobalActions';
import axios from '../util/Axios';
import Header from '../components/Header';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const login = (email, password) => {
    axios
      .post('/users/login-web', {
        email: email,
        password: password,
      })
      .then((response) => {
        if (response.data.authUrl) {
          // MFA required — redirect to Duo; ValidateMFA.js handles the callback
          window.location.href = response.data.authUrl;
        } else {
          // MFA not required — direct login
          dispatch({
            type: actions.LOGIN,
            payload: { user: response.data.user, auth: response.data.authToken },
          });
          navigate('/', { replace: true });
        }
      });
  };

  return (
    <>
      <Header logged="false" />

      <Paper
        sx={{
          margin: 'auto',
          marginTop: '160px',
          maxWidth: '500px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          padding: '24px'
        }}
      >
        <TextField label="Email" value={email} onChange={(event) => setEmail(event.target.value)} />
        <TextField
        
          label="Password"
          type="password"
          value={password}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              setPassword(event.target.value);
              login(email, event.target.value);
            }
          }}
          onChange={(event) => setPassword(event.target.value)}
        />
        <Button variant="contained" color="primary" onClick={() => login(email, password)}>
          Login
        </Button>
        <Link to={'/forgotpass'} style={{ alignSelf: 'center' }}>Forgot password?</Link>
      </Paper>
    </>
  );
}
